// extracted by mini-css-extract-plugin
module.exports = {"link":"da51a739f7--link--fKr7E","link--m":"da51a739f7--link--m--g7C_s"};